import { Inject, Pipe, PipeTransform } from '@angular/core';
import { timer } from 'rxjs';
import { map } from 'rxjs/operators';

import { moment } from '../lib/moment';
import { MomentFormatter } from '../services/moment-formatter';

const INTERVAL = 15000;

@Pipe({ name: 'elapsedTime' })
export class ElapsedTimePipe implements PipeTransform {
  constructor(@Inject(MomentFormatter) private formatter) {}

  public transform(time) {
    if (!time) return;
    return timer(0, INTERVAL)
      .pipe(map(() => this._format(time)))
    ;
  }

  private _format(time) {
    const now = moment();
    let duration = now.diff(time, 'seconds');
    const formatter = this.formatter;

    if (duration < 0) duration = 0;

    if (duration < 60) {
      return `${duration} sec`;
    } else if (duration < 60 * 60) {
      const minutes = Math.floor(duration / 60);
      return `${minutes} min`;
    } else if (now.isSame(time, 'day')) {
      return formatter.format(time, 'time');
    } else {
      return formatter.format(time, 'date');
    }
  }
}
